import React from 'react';
import { RefreshCw } from 'lucide-react';

// Version du backoffice - BUG-6 fix: centralisé sur Build 304
const BUILD_VERSION = "304";
const BUILD_DATE = "2026-02-27";

// Fonction de rafraîchissement PWA
const handleRefreshPWA = () => {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.getRegistrations().then(registrations => {
      registrations.forEach(registration => registration.unregister());
    });
  }
  caches.keys().then(names => {
    names.forEach(name => caches.delete(name));
  });
  window.location.reload(true);
};

export const Header = ({ title, subtitle }) => {
  return (
    <header className="bg-white border-b border-gray-200 px-8 py-4 flex items-center justify-between">
      <div>
        <h2 className="text-2xl font-bold text-gray-900">{title}</h2>
        {subtitle && <p className="text-sm text-gray-500 mt-1">{subtitle}</p>}
      </div>
      <div className="flex items-center gap-3">
        <div className="text-right">
          <p className="text-xs text-gray-400">Build {BUILD_VERSION}</p>
          <p className="text-[10px] text-gray-300">{BUILD_DATE}</p>
        </div>
        <button
          onClick={handleRefreshPWA}
          className="p-2 rounded-lg bg-blue-50 hover:bg-blue-100 active:bg-blue-200 transition-all"
          title="Rafraîchir l'application (vider le cache)"
        >
          <RefreshCw className="w-4 h-4 text-blue-500" />
        </button>
      </div>
    </header>
  );
};
